// ローカルストレージに状態を保存する
export const saveState = (stateName, data) => {
  localStorage.setItem(stateName, JSON.stringify(data));
};

// ローカルストレージから作業状態を取得する
export const loadState = (stateName) => {
  return JSON.parse(localStorage.getItem(stateName));
};

// ローカルストレージから指定して削除する
export const deleteState = (stateName) => {
  localStorage.removeItem(stateName);
};

// ローカルストレージをクリアして初期状態に戻す
export const resetState = () => {
  localStorage.removeItem("location"); // 現在位置
  localStorage.removeItem("checkMapState"); // 地図のチェック状態
  localStorage.removeItem("pdfSetting"); // PDFの設定
  localStorage.removeItem("chibanPolygonDlSetting"); // 地番ポリゴンダウンロードの設定
  localStorage.removeItem("defaultDrawColor"); // 図形の色設定
  localStorage.removeItem("isReflectHistoryOnMap"); // 購入履歴を反映
};
